import { dataTrophy } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrophy = /*#__PURE__*/createIcon(dataTrophy)
export default IconTrophy
